<template>
  <div :style="chartHeight">
    <canvas ref="chart-canvas"></canvas>
  </div>
</template>

<script>
import { Chart, registerables } from 'chart.js';

Chart.register(...registerables);

export default {
  name: 'ChartViewer',
  props: {
    type: String,
    data: Object,
    options: Object,
    isEnlarge: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      chartObj: null,
    };
  },
  mounted() {
    const ctx = this.$refs['chart-canvas'];
    this.chartObj = new Chart(ctx, {
      type: this.type,
      data: this.data,
      options: this.chartOptions,
    });
  },
  computed: {
    chartHeight() {
      if(this.isEnlarge) {
        return {height: '80vh'};
      } else {
        return {height: '200px'};
      }
    },
    chartOptions() {
      return { ...this.options, ...{ maintainAspectRatio: false } };
    },
  },
  watch: {
    type(newVal) {
      this.chartObj.destroy();
      const ctx = this.$refs['chart-canvas'];
      this.chartObj = new Chart(ctx, {
        type: newVal,
        data: this.data,
        options: this.chartOptions,
      });
    },
    data(newVal) {
      this.chartObj.data = newVal;
      this.chartObj.update();
    },
    options() {
      this.chartObj.options = this.chartOptions;
      this.chartObj.update();
    },
  },
};
</script>

<style scoped></style>